import { ReactNode } from "react";

import { Box, DialogContentText, Divider } from "@mui/material";

import ModalUI from "./ModalUI";
import CustomizedButton from "../../Custom/CustomizedButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

interface Props {
  open: boolean;
  title: string;
  message?: ReactNode | string;
  noDivider?: boolean;
  handleClose: () => void;
  action: () => void;
  isLoading?: boolean;
  titleColor?: string;
}

const DeleteConfirmation = ({
  open,
  title,
  message,
  noDivider,
  handleClose,
  action,
  isLoading,
  titleColor,
}: Props) => {
  return (
    <ModalUI
      title={title}
      open={open}
      handleClose={handleClose}
      maxWidth="xs"
      fullWidth
      altTitleColor={titleColor}
      action={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: ".5rem",
          }}
        >
          <CustomizedButton
            title="ยกเลิก"
            variant="outlined"
            onClick={handleClose}
          />
          <CustomizedButton
            title="ยืนยัน"
            variant="contained"
            onClick={action}
            disabled={isLoading}
          />
        </Box>
      }
    >
      {message && (
        <>
          {!noDivider && <Divider />}
          <DialogContentText>
            <Box textAlign="center">
              <DeleteForeverIcon
                sx={{
                  fontSize: "4rem",
                  marginTop: 1,
                  color: "gray.light",
                }}
              />
              {message}
            </Box>
          </DialogContentText>
          {!noDivider && <Divider sx={{ marginTop: "1rem" }} />}
        </>
      )}
    </ModalUI>
  );
};

export default DeleteConfirmation;
